

import Link from '@src/components/base/Link';

import SidebarItem from './SidebarItem';

const StyleSheet = {
  listItem: {
    '&:has(.Mui-active)': {
    },
  },
  listItemButton: (theme) => ({
    pl: '24px',
    '&.Mui-active': {
      pl: '21px',
      background: 'inherit',
      borderLeft: '3px solid',
      borderColor: theme.palette.red[200],
      '&:hover': {
        background: 'inherit',
      },
      '& .MuiTypography-root': {
        color: theme.palette.common.white,
      },
    },  
  }),
};

function SidebarNavItem(props) {
  return (
    <SidebarItem
      component={Link}
      slotProps={{ listItem: { sx: StyleSheet.listItem }, listItemButton: { sx: StyleSheet.listItemButton } }}
      {...props}
    />
  );
}

SidebarNavItem.displayName = 'SidebarNavItem';
export default SidebarNavItem;
